export default function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        .input[type=browser-storage-setter-text] {
            display:none;
        }
        .width100{
          width: 100%;
        }
  `;
  document.head.appendChild(style);
  traitManager.addType('finder-query-param-trait', {
    createInput({ trait }) {
      const traitTitle = trait.get('title');
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
      <div id="${traitTitle}_param">
        <div class="form-group">
          <div id="${traitTitle}-select">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
        </div>
      </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      commonOnTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataMapTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
}
const onDataMapTraitsUpdate = (elInput, component, traits, title) => {
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector(`#${title}`);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
  }
};

const commonOnTraitsChange = (elInput, component, traits, title) => {
  console.log('title imagine_pay', title);
  console.log('traits imagine_pay', traits);
  const traitsFieldAttr = traits.get('name');
  console.log('traitsFieldAttr imagine_pay', traitsFieldAttr);
  const select = elInput.querySelector(`#${title}`);
  let selectFieldValue = select.value;
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();
  if (selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  }
  component.setAttributes(attr);
  component.set(traitsFieldAttr, selectFieldValue ? selectFieldValue : '');
};
